import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import {
  fetchPatientsAsync,
  resetPatientStatus,
} from '../../patients/patientsSlice'
import IPDPatientTable from './IPDPatientTable'
import IpdSearch from './IpdSearch'
import IpdVisitCreateForm from './IpdVisitCreateForm'
import '../bms.scss'
import {
  selectedReload,
  selectedVisitId,
  selectPatientId,
  setQueryParam,
} from './IpdVisitSlice'
import { Dialog, IconButton, DialogContent } from '@mui/material'
import { allocation } from '../modals'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'
import { useNavigate, useLocation } from 'react-router-dom'
import CloseIcon from '@mui/icons-material/Close'
import { paramsBedId, paramsBedStatus, paramsId } from './Constants'
import DropdownMenu from '../../../components/DropdownMenu/DropdownMenu'
import { toast } from 'react-toastify'
import { deleteVisitId, archiveVisitId } from '../../../services/OPDService'
import { setSelectedVisitId } from '../../opd/OpdPatientSlice'
import { exportExcel } from '../../../utils/hooks/Utils'
import { dropDownMenuKeys, noDataMessage } from '../../../components/constants'

const IpdDashBoard = () => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const locationParams = new URLSearchParams(location?.search)
  const id = locationParams?.get(paramsId)
  const bedId = locationParams?.get(paramsBedId)
  const bedStatus = locationParams?.get(paramsBedStatus)
  const [filteredData, setFilteredData] = useState<any>(null)
  useEffect(() => {
    if (id) {
      dispatch(setQueryParam({ patientId: id }))
    }

    dispatch(fetchPatientsAsync())
    return () => {
      dispatch(resetPatientStatus())
    }
  }, [dispatch, id])

  // const [show, setShow] = useState<boolean>(false)
  const [initialDisplay, setInitialDisplay] = useState<boolean>(false)
  // const [query, setQuery] = useState<string>('')
  const [param, setParam] = useState<string>('')
  // const [patientId, setPatientId] = useState<string>('')
  const [dataUpdated, setDataUpdated] = useState(false)
  const selectedPatientId = useAppSelector(selectPatientId)
  const [visit, setVisit] = useState(false)
  const navigate = useNavigate()
  useEffect(() => {
    if (selectedPatientId) {
      setInitialDisplay(true)
    }
  }, [selectedPatientId])
  const handleSearch = (q: string, p: string) => {
    // setQuery(q)
    setParam(p)
    // setPatientId('')
    setInitialDisplay(true)
    if (!q || !p) {
      // setShow(false)
    } else {
      // setShow(true)
    }
    dispatch(setQueryParam({ patientId: p }))
  }
  const visitCreate = () => {
    setVisit(true)
  }
  const handleCloseForm = () => {
    setVisit(false)
    setDataUpdated((prev) => !prev)
  }
  const handleBackToDashboard = () => {
    navigate('/bedIpd/bedAssignmentList')
  }
  const visits = useAppSelector(selectedVisitId)
  const reload = useAppSelector(selectedReload)
  const deleteVisit = async () => {
    const response = await deleteVisitId(visits)
    if (response?.success) {
      toast?.success(response?.message)
      dispatch(setQueryParam({ setSelectedVisitId: null }))
      dispatch(fetchPatientsAsync())
      dispatch(setQueryParam({ reload: reload + 1 }))
    } else {
      toast?.error(response?.message)
      dispatch(setSelectedVisitId(null))
      dispatch(fetchPatientsAsync())
      dispatch(setQueryParam({ reload: reload + 1 }))
    }
  }
  const archiveVisit = async () => {
    const response = await archiveVisitId(visits)
    if (response?.success) {
      toast.success(response?.message)
      dispatch(setQueryParam({ setSelectedVisitId: null }))
      dispatch(setQueryParam({ reload: reload + 1 }))
    } else {
      toast.error(response?.message)
      dispatch(setSelectedVisitId(null))
      dispatch(setQueryParam({ reload: reload + 1 }))
    }
  }
  const handleExport = () => {
    if (filteredData && filteredData?.length > 0) {
      exportExcel(filteredData)
    } else {
      toast.error(noDataMessage)
    }
  }
  const handleSelect = (e: any) => {
    if (e?.[0] === dropDownMenuKeys?.delete) {
      deleteVisit()
    }
    if (e?.[0] === dropDownMenuKeys?.archive) {
      archiveVisit()
    }
    if (e?.[0] === dropDownMenuKeys?.export) {
      handleExport()
    }
  }
  const handleFilteredData = (e: any) => {
    setFilteredData(e)
  }
  return (
    <>
      {visit && (
        <Dialog open={visit} maxWidth='sm'>
          <IconButton
            onClick={handleCloseForm}
            className='flex-end f12 ml-auto'
          >
            <CloseIcon fontSize='small' />
          </IconButton>
          <DialogContent className='padding20 margin2'>
            <IpdVisitCreateForm
              patientExist='noExist'
              onClose={handleCloseForm}
              patientUhid={param ? param : id || selectedPatientId}
              bedId={bedId}
              bedStatus={bedStatus}
            />
          </DialogContent>
        </Dialog>
      )}
      <div className='layoutcontent'>
        <div className='dashboard-context ipd-dashboard-content'>
          <span className='margin3 fw600'>
            <IconButton onClick={handleBackToDashboard}>
              <KeyboardBackspaceIcon />
            </IconButton>
            {allocation.ipVisitDashboard}
          </span>
          <div className='ipd-dashboard-menu'>
            <div className='ipd-dashboard-submenu'>
              <DropdownMenu
                onSelect={handleSelect}
                actionOptions={[
                  {
                    label: dropDownMenuKeys?.exportKey,
                    value: dropDownMenuKeys?.export,
                  },
                  {
                    label: dropDownMenuKeys?.deleteKey,
                    value: dropDownMenuKeys?.delete,
                  },
                  {
                    label: dropDownMenuKeys?.archiveKey,
                    value: dropDownMenuKeys?.archive,
                  },
                ]}
                selectedId={false}
              />
            </div>
            <IpdSearch onSearch={handleSearch} onCreateVisit={visitCreate} />
          </div>
        </div>
        <IPDPatientTable
          patientId={selectedPatientId || id}
          dataUpdated={dataUpdated}
          initialDisplay={initialDisplay}
          bedId={bedId}
          bedStatus={bedStatus}
          reload={reload}
          onFilterData={handleFilteredData}
        />
      </div>
    </>
  )
}
export default IpdDashBoard
